module.exports = __webpack_public_path__ + "static/main-500-86d95debfda780b81663e4fea7cfff19.png";